import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';
import NumberInput from './NumberInput';
import Checkbox from './Checkbox';
import FileInput from './FileInput';

const components = {
  number: NumberInput,
  file: FileInput,
  checkbox: Checkbox,
  radio: RadioButton,
};

const Input = ({ type, ...props }) => {
  const Component = components[type];
  return (
    <Component {...props} />
  );
};

Input.propTypes = {
  type: PropTypes.string.isRequired
};

export default Input;
